import { useNavigate } from 'react-router-dom';
import styles from '../styles/app.module.css';

export function MakeYourOwnButton() {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className={styles.makeYourOwn}
      onClick={() => navigate('/builder')}
      aria-label="Make your own custom photobooth"
    >
      <span aria-hidden style={{ fontSize: 14 }}>✦</span>
      <span>Make your own</span>
    </button>
  );
}
